import ENV from '../env.json';

export const _APIRoutes = {
    enum: {
        digitalReceiptType: `${ENV.api}/Enum/DigitalReceiptType`,
        digitalReceiptState: `${ENV.api}/Enum/DigitalReceiptState`,
    },
    digitalReceipts: (trackingCode: string) => `${ENV.api}/DigitalReceipt/${trackingCode}`,
};
